export default __webpack_public_path__ + "static/media/login.d74e2e6b.jpg";